import { render, staticRenderFns } from "./ButtonEdit.vue?vue&type=template&id=72802168&scoped=true&"
import script from "./ButtonEdit.vue?vue&type=script&lang=js&"
export * from "./ButtonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72802168",
  null
  
)

export default component.exports